import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/KebunPRT.css";

const KebunPRPLD = () => {
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const [tanggal, setTanggal] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [panenDetail, setPanenDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  // Handle Logout
  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  // Fetch detail panen
  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    const fetchPanenDetail = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/view_panen_detail",
          { withCredentials: true }
        );
        const panens = response.data.panens;

        const detail = panens.find((item) => item.id === parseInt(id, 10));

        if (detail) {
          setPanenDetail(detail);
        } else {
          Swal.fire("Data tidak ditemukan", "Detail panen tidak ada", "error");
        }
      } catch (error) {
        console.error("Error saat mengambil data panen:", error);
        Swal.fire("Error", "Gagal mengambil data panen", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchPanenDetail();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleValidate = () => {
    Swal.fire({
      title: "Validasi Rencana Panen",
      text: "Tentukan status persetujuan untuk rencana panen ini.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Setujui (Approved)",
      cancelButtonText: "Tolak (Rejected)",
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitValidation("approved", "");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Masukkan Alasan Penolakan",
          input: "textarea",
          inputPlaceholder: "Tuliskan alasan penolakan di sini...",
          inputValidator: (value) => {
            if (!value) {
              return "Alasan penolakan diperlukan!";
            }
          },
          showCancelButton: true,
          confirmButtonText: "Kirim Penolakan",
          confirmButtonColor: "#dc3545",
        }).then((noteResult) => {
          if (noteResult.isConfirmed) {
            submitValidation("rejected", noteResult.value);
          }
        });
      }
    });
  };

  const submitValidation = (status, note) => {
    axios
      .post("https://c-greenproject.org:7500/validate_rencana_panen", {
        id: panenDetail.id,
        status,
        note,
      })
      .then((response) => {
        Swal.fire({
          title: "Sukses!",
          text: response.data.message || `Data berhasil di-${status}`,
          icon: "success",
          confirmButtonColor: "#198754",
        }).then(() => {
          // Update state lokal agar tidak perlu refresh halaman
          setPanenDetail({ ...panenDetail, status: status, catatan: note });
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.response ? error.response.data.error : error.message,
          icon: "error",
          confirmButtonColor: "#dc3545",
        });
      });
  };

  // Helper Warna Status Validasi
  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s === "approved" || s === "disetujui") {
      return <span className="badge bg-success-subtle text-success px-4 py-2 rounded-pill border border-success-subtle fw-semibold fs-6">Approved</span>;
    }
    if (s === "rejected" || s === "ditolak") {
      return <span className="badge bg-danger-subtle text-danger px-4 py-2 rounded-pill border border-danger-subtle fw-semibold fs-6">Rejected</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis px-4 py-2 rounded-pill border border-warning-subtle fw-semibold fs-6">Menunggu Validasi</span>;
  };

  // Komponen Label & Value Row Anti-Pecah
  const DetailRow = ({ label, value }) => (
    <div className="d-flex justify-content-between align-items-center py-3 border-bottom" style={{ gap: "20px" }}>
      <span className="text-muted fw-semibold text-nowrap">{label}</span>
      <span className="fw-bold text-dark text-end" style={{ wordBreak: "break-word" }}>{value || "-"}</span>
    </div>
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!panenDetail) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light flex-column">
        <h4 className="text-muted">Data Rencana Panen tidak ditemukan.</h4>
        <button className="btn btn-outline-secondary mt-3 rounded-pill" onClick={handleBack}>
          Kembali ke Daftar
        </button>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2" onClick={handleLogout}>
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div onClick={() => navigate("/kebun")} className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${location.pathname === "/kebun" ? "bg-success text-white" : ""}`} style={{ cursor: "pointer" }}>
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/kebun" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div onClick={() => navigate("/KebunP")} className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${location.pathname.includes("/kebunPRP") || location.pathname === "/KebunP" ? "bg-success text-white" : ""}`} style={{ cursor: "pointer" }}>
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname.includes("/kebunPRP") || location.pathname === "/KebunP" ? "brightness(0) invert(1)" : "none" }} /> Petani
            </div>
            <div onClick={() => navigate("/KebunL")} className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${location.pathname === "/KebunL" ? "bg-success text-white" : ""}`} style={{ cursor: "pointer" }}>
              <img src="/static/shipping.png" alt="Harvest" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/KebunL" ? "brightness(0) invert(1)" : "none" }} /> Logistik
            </div>
            <div onClick={() => navigate("/pabrik")} className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${location.pathname === "/pabrik" ? "bg-success text-white" : ""}`} style={{ cursor: "pointer" }}>
              <img src="/static/factory.png" alt="Factory" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/pabrik" ? "brightness(0) invert(1)" : "none" }} /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          {/* Top Bar Area */}
          <div className="content-box mb-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center">
            <div>
              <h3 className="fw-bold text-dark mb-1">Detail Rencana Panen</h3>
              <p className="text-muted mb-0 font-monospace">ID Panen: #{panenDetail.id}</p>
            </div>
            <div className="d-flex gap-2 mt-3 mt-md-0">
              <button className="btn kembali-button px-4" onClick={handleBack}>
                Kembali
              </button>
              
              {/* Tombol Validasi - Hilang jika sudah divalidasi */}
              {panenDetail.status?.toLowerCase() !== "approved" && panenDetail.status?.toLowerCase() !== "rejected" && (
                <button className="btn btn-success shadow-sm px-4 fw-bold" onClick={handleValidate}>
                  <i className="fa fa-check-circle me-2"></i>Validasi Pengajuan
                </button>
              )}
            </div>
          </div>

          <div className="row g-4">
            {/* Kolom Kiri: Info Panen & Petani */}
            <div className="col-12 col-xl-7">
              <div className="content-box h-100">
                <h5 className="fw-bold text-success mb-4 pb-2 border-bottom">Informasi Panen & Lahan</h5>
                
                <DetailRow label="Nama Petani" value={panenDetail.nama} />
                <DetailRow label="Alamat / Lokasi" value={panenDetail.alamat} />
                <DetailRow label="Jenis Sawit" value={panenDetail.jenis_sawit} />
                <DetailRow label="Luas Lahan" value={panenDetail.luas_lahan ? `${panenDetail.luas_lahan} Hektar` : "-"} />
                <DetailRow label="Perkiraan Jumlah" value={panenDetail.jumlah_panen ? `${Number(panenDetail.jumlah_panen).toLocaleString("id-ID")} Kg` : "-"} />
                <DetailRow label="Tgl. Penanaman" value={panenDetail.tanggal_panen} />
                
                <div className="mt-5"></div>

                <h5 className="fw-bold text-success mb-4 pb-2 border-bottom">Informasi Tujuan</h5>
                <DetailRow label="Pabrik Tujuan" value={panenDetail.pabrik_tujuan} />
                <DetailRow label="Vendor Logistik" value={panenDetail.logistik} />
                
                <div className="d-flex justify-content-between align-items-center py-3 border-bottom" style={{ gap: "20px" }}>
                  <span className="text-muted fw-semibold text-nowrap">Resi Pengiriman</span>
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    {Array.isArray(panenDetail["Resi pengiriman"]) && panenDetail["Resi pengiriman"].length > 0 ? (
                      panenDetail["Resi pengiriman"].map((resi, idx) => (
                        <span key={idx} className="bg-light text-dark border rounded px-3 py-1 font-monospace fw-semibold shadow-sm" style={{ fontSize: "0.9rem" }}>
                          {resi}
                        </span>
                      ))
                    ) : (
                      <span className="fst-italic text-muted">-</span>
                    )}
                  </div>
                </div>

              </div>
            </div>

            {/* Kolom Kanan: Status Validasi */}
            <div className="col-12 col-xl-5">
              <div className="content-box h-100" style={{ backgroundColor: "#fbfbfc" }}>
                <h5 className="fw-bold text-dark mb-4 pb-2 border-bottom">Status Validasi</h5>
                
                <div className="mb-4">
                  <p className="text-muted fw-semibold mb-2">Status Saat Ini</p>
                  <div>{getStatusBadge(panenDetail.status)}</div>
                </div>

                <div className="mb-4">
                  <p className="text-muted fw-semibold mb-1">Tanggal Pengajuan</p>
                  <p className="fw-bold text-dark fs-5">{panenDetail.tanggal_permohonan || "-"}</p>
                </div>

                <div className="mb-4">
                  <p className="text-muted fw-semibold mb-1">Tanggal Diperiksa</p>
                  <p className="fw-bold text-dark fs-5">{panenDetail.tanggal_persetujuan || "Belum diperiksa"}</p>
                </div>

                <div className="mb-0">
                  <p className="text-muted fw-semibold mb-2">Catatan / Alasan</p>
                  <div className="bg-white p-3 rounded-3 border shadow-sm">
                    <p className="mb-0 fw-medium text-secondary">
                      {panenDetail.catatan || <span className="fst-italic">Tidak ada catatan tambahan.</span>}
                    </p>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default KebunPRPLD;